/**
 * Global layout chrome — single SiteHeader (TopBar + category nav), footer, mobile tabs.
 */
export const getLayoutChrome = (pathname) => {
  const isAdmin =
    pathname.startsWith("/admin") || pathname.startsWith("/superadmin");
  const isShoppingProfileOnboarding =
    pathname === "/onboarding/shopping-profile";
  const isAuthPage =
    pathname === "/login" ||
    pathname === "/forgot-password" ||
    pathname.startsWith("/reset-password");

  return {
    showFooter: !isShoppingProfileOnboarding && !isAuthPage,
    showTopBar: !isShoppingProfileOnboarding && !isAuthPage,
    topBarVariant: "default",
    showMobileBottomNav:
      !isAdmin && !isShoppingProfileOnboarding && !isAuthPage,
  };
};
